class KomtoProductFamilyPicker extends HTMLElement {
  connectedCallback() {
    this.productInfo = this.closest('.product-info');
    this.onVariantChange = this.onVariantChange.bind(this);
    this.productInfo?.addEventListener('change', this.onVariantChange);
    this.updateOptions(this.dataset.currentColor || '');
  }

  disconnectedCallback() {
    this.productInfo?.removeEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (!event.target.matches('.js-option')) return;
    this.updateOptions(event.target.value);
  }

  updateOptions(color) {
    this.querySelectorAll('[data-family-option]').forEach((item) => {
      const link = item.querySelector('.komto-product-family__option');
      const payload = item.querySelector('[data-family-variants]');
      if (!link || !payload) return;

      let variants = [];
      try {
        variants = JSON.parse(payload.textContent);
      } catch (error) {
        console.warn('KOMTO size selector: invalid variant payload', error);
        return;
      }

      // KOMTO (BAN-179, owner decision 52): when the selected finish is sold out in this model, link
      // to the model's first finish in stock; only a model with nothing in stock stays disabled.
      let match = variants.find((variant) => variant.color === color);
      const isCurrent = item.dataset.productId === this.dataset.currentProductId;
      if (!isCurrent && (!match || !match.available)) match = variants.find((variant) => variant.available) || match;
      const unavailable = !match || !match.available;
      item.classList.toggle('is-unavailable', unavailable);

      if (match?.url) link.dataset.variantUrl = match.url;
      if (unavailable) {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
      } else {
        link.href = match.url;
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
      }
    });
  }
}

if (!customElements.get('product-family-picker')) {
  customElements.define('product-family-picker', KomtoProductFamilyPicker);
}
